import { type MouseEvent } from 'react';
import { cn } from '@/shared/utils/cn';

interface NativeShareButtonProps {
  title: string;
  url?: string | null;
  className?: string;
  onShareClick?: () => void;
}

export function NativeShareButton({ title, url, className, onShareClick }: NativeShareButtonProps) {
  const handleShare = (e: MouseEvent) => {
    e.stopPropagation();
    onShareClick?.();
    const shareUrl = url ?? window.location.href;
    const shareData = {
      title,
      text: 'Check out this design I found on BlueStone',
      url: shareUrl,
    };
    if (navigator.canShare?.(shareData)) {
      navigator.share(shareData).catch(() => {});
    } else {
      window.open(`whatsapp://send?text=${encodeURIComponent(`${title} | ${shareUrl}`)}`, '_blank');
    }
  };

  return (
    <button
      type="button"
      aria-label="Share product"
      onClick={handleShare}
      className={cn(
        'flex h-[34px] w-[34px] items-center justify-center rounded-full border border-[#e2e2e2] bg-white',
        'shadow-[0_0_3px_0_rgba(25,25,25,0.15)]',
        className
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-[18px] w-[18px] text-[#959595]"
        aria-hidden="true"
      >
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </svg>
    </button>
  );
}
